import { withEditPermissionCheck } from '@app/shared/hocs/withEditPermissionCheck';
import Checkbox from '@material-ui/core/Checkbox';

export const RoleProtectedCheckbox = withEditPermissionCheck(Checkbox);
